import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisualGuideService } from 'ZalamoLibrary/src/lib/ui/visual-guide/visual-guide.service';
import { VisualGuideInitiatorDirective } from './visual-guide-initiator.directive';
import { VisualGuidesInlineListComponent } from './visual-guides-inline-list/visual-guides-inline-list.component';
import { ZalamoDialogModule } from '@ui/zalamo-dialog/zalamo-dialog.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VisualGuideButtonComponent } from './visual-guide-button/visual-guide-button.component';

@NgModule({
  declarations: [
    VisualGuideInitiatorDirective,
    VisualGuidesInlineListComponent,
    VisualGuideButtonComponent,
  ],
  exports: [
    VisualGuideInitiatorDirective,
    VisualGuidesInlineListComponent,
    VisualGuideButtonComponent,
  ],
  imports: [
    CommonModule,
    ZalamoDialogModule,
    OverlayModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class VisualGuideModule {
  constructor(visualGuideService: VisualGuideService) {}
}
